var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarvanaAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66538 21.9516L14.2967 4.67569C15.0777 3.40661 16.9223 3.40661 17.7033 4.67568L28.3346 21.9516C29.1546 23.2841 28.1959 24.9998 26.6313 24.9998H5.36869C3.80405 24.9998 2.84535 23.2841 3.66538 21.9516Z",
    stroke: "#00619E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7639 17.4717H16.2418C16.3762 17.4717 16.5106 17.3522 16.5255 17.2327L17.1079 13.0365V11.3639C17.1079 11.2146 16.9735 11.0802 16.8242 11.0802H15.1815C15.0322 11.0802 14.8978 11.2146 14.8978 11.3639V13.0663L15.4802 17.2327C15.4951 17.3522 15.6295 17.4717 15.7639 17.4717ZM14.7783 20.4583C14.7783 21.1303 15.3309 21.6829 15.9879 21.6829C16.6749 21.6829 17.2274 21.1303 17.2274 20.4583C17.2274 19.7863 16.6749 19.2189 15.9879 19.2189C15.3309 19.2189 14.7783 19.7863 14.7783 20.4583Z",
    fill: "#00AED9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarvanaAlertIcon);
export default __webpack_public_path__ + "static/media/carvana-alert-icon.f07749a4.svg";
export { ForwardRef as ReactComponent };